"use strict";
/* eslint-disable no-new-func */
/* eslint-disable @typescript-eslint/ban-types */
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryEvalExpr = exports.evalExpr = exports.processMaybeEval = void 0;
const tslib_1 = require("tslib");
const cloneDeep_1 = tslib_1.__importDefault(require("../utils/cloneDeep"));
/**
 * 如果传入的对象是个 `{ $expr: "表达式" }` 就做执行并返回结果，否则返回传入的对象的拷贝
 *
 * @param extraCtx 可为表达式注入其他的上下文对象，以便表达式引用上下文里面的属性
 */
function processMaybeEval(data, evalCtx, extraCtx) {
    if (data === undefined)
        return undefined;
    if (data && typeof data === 'object'
        && ('$expr' in data) && typeof data.$expr === 'string'
        && Object.keys(data).length === 1) {
        return evalExpr(data.$expr, extraCtx, evalCtx);
    }
    return (0, cloneDeep_1.default)(data);
}
exports.processMaybeEval = processMaybeEval;
function evalExpr(expr, ...ctx) {
    const ctx2 = ctx.filter(x => !!x && typeof x === 'object');
    const ctxNames = ctx2.map((_, i) => `__$ctx${i}`);
    let fn;
    try {
        fn = new Function(...ctxNames, `${ctxNames.map(name => `with(${name})`).join(' ')} return (\n${expr}\n)`);
    }
    catch (_a) {
        fn = new Function(...ctxNames, `${ctxNames.map(name => `with(${name})`).join(' ')} {\n${expr}\n}`);
    }
    return fn(...ctx2);
}
exports.evalExpr = evalExpr;
function tryEvalExpr(expr, defaultValue, ...ctx) {
    try {
        return evalExpr(expr, ...ctx);
    }
    catch (err) {
        return defaultValue;
    }
}
exports.tryEvalExpr = tryEvalExpr;
//# sourceMappingURL=eval.js.map